import styled from "styled-components";
export var MapOverlayPopup = styled.div.withConfig({
  displayName: "styled__MapOverlayPopup",
  componentId: "xjejci-0"
})(["font-size:12px;line-height:1.5;min-width:250px;"]);
export var PopupRow = styled.div.withConfig({
  displayName: "styled__PopupRow",
  componentId: "xjejci-1"
})(["margin-top:6px;"]);
export var PopupTitle = styled.div.withConfig({
  displayName: "styled__PopupTitle",
  componentId: "xjejci-2"
})(["font-size:18px;font-weight:500;margin-bottom:6px;"]);
//# sourceMappingURL=styled.js.map